export default "__VITE_ASSET__DtTrVZPL__"